import { i18n } from '@/plugin/i18n';

export function getUserAge(birthYear) {
  let age = null;
  let ageRange = null;

  if (Number.isInteger(birthYear)) {
    let now = new Date();
    age = now.getFullYear() - birthYear;
    if (age >= 60) {
      ageRange = i18n.global.t('userInfoCommon.form.age.options.60over');
    } else if (50 <= age && age < 60) {
      ageRange = i18n.global.t('userInfoCommon.form.age.options.50');
    } else if (40 <= age && age < 50) {
      ageRange = i18n.global.t('userInfoCommon.form.age.options.40');
    } else if (30 <= age && age < 40) {
      ageRange = i18n.global.t('userInfoCommon.form.age.options.30');
    } else if (20 <= age && age < 30) {
      ageRange = i18n.global.t('userInfoCommon.form.age.options.20');
    } else if (0 <= age && age < 20) {
      ageRange = i18n.global.t('userInfoCommon.form.age.options.10');
    }
  }

  return {
    age: age,
    ageRange: ageRange
  };
}
